import {
  CREATE_TEAM_FAILED,
  CREATE_TEAM_LOADING,
  CREATE_TEAM_SUCCESS,
  EDIT_MEMBER_FAILED,
  EDIT_MEMBER_LOADING,
  EDIT_MEMBER_SUCCESS,
  INVITE_USER_FAILED,
  INVITE_USER_LOADING,
  INVITE_USER_SUCCESS,
  REMOVE_MEMBER_FAILED,
  REMOVE_MEMBER_LOADING,
  REMOVE_MEMBER_SUCCESS,
  TEAMS_FAILED,
  TEAMS_LOADING,
  TEAMS_SUCCESS
} from "../constants/actionTypes"
import { deleteRequest, getRequest, patchRequest, postRequest } from "../helpers/fetchHandler"

export function fetchTeams() {
  return async dispatch => {
    dispatch({ type: TEAMS_LOADING })

    const url = "/api/v1/profile/teams"
    try {
      const response = await getRequest({ url, auth: true })
      dispatch({ type: TEAMS_SUCCESS, payload: response })
      return response
    } catch (error) {
      dispatch({ type: TEAMS_FAILED, error })
      throw error
    }
  }
}

export function createTeam(data) {
  return async dispatch => {
    dispatch({ type: CREATE_TEAM_LOADING })

    const url = "/api/v1/profile/teams"
    try {
      const response = await postRequest({ url, data, auth: true })
      dispatch({ type: CREATE_TEAM_SUCCESS, payload: response })
      return response
    } catch (error) {
      dispatch({ type: CREATE_TEAM_FAILED, error })
      throw error
    }
  }
}

export function inviteUserToTeam(teamId, data) {
  return async dispatch => {
    dispatch({ type: INVITE_USER_LOADING })

    const url = `/api/v1/profile/team/${teamId}/invite`
    try {
      const response = await postRequest({ url, data, auth: true })
      dispatch({ type: INVITE_USER_SUCCESS })
      return response
    } catch (error) {
      dispatch({ type: INVITE_USER_FAILED, error })
      throw error
    }
  }
}

export function removeTeamMember(teamId, teamUserId) {
  return async dispatch => {
    dispatch({ type: REMOVE_MEMBER_LOADING })

    const url = `/api/v1/profile/team/${teamId}/remove/${teamUserId}`
    try {
      const response = await deleteRequest({ url, auth: true })
      dispatch({ type: REMOVE_MEMBER_SUCCESS, meta: { teamId, teamUserId } })
      return response
    } catch (error) {
      dispatch({ type: REMOVE_MEMBER_FAILED, error })
      throw error
    }
  }
}

export function editTeamMember(teamId, teamUserId, data) {
  return async dispatch => {
    dispatch({ type: EDIT_MEMBER_LOADING })

    const url = `/api/v1/profile/team/${teamId}/edit/${teamUserId}`
    try {
      const response = await patchRequest({ url, data, auth: true })
      dispatch({ type: EDIT_MEMBER_SUCCESS })
      return response
    } catch (error) {
      dispatch({ type: EDIT_MEMBER_FAILED, error })
      throw error
    }
  }
}

// export function deleteTeam(id) {
//   return async dispatch => {
//     dispatch({ type: DELETE_TEAM_LOADING })

//     const url = `/api/v1/campaigns/${id}`
//     try {
//       await deleteRequest({ url, auth: true })
//       dispatch({ type: DELETE_TEAM_SUCCESS, payload: id })
//       return Promise.resolve()
//     } catch (error) {
//       dispatch({ type: DELETE_TEAM_FAILED, error })
//       throw error
//     }
//   }
// }
